import { __makeTemplateObject } from "tslib";
import { css, getParsePaletteColor, px, } from '../../../foundation';
import { RcIconSizes, switchSize } from '../utils';
export var IconStyle = function (props) {
    var onClick = props.onClick, sizeProp = props.size, color = props.color, iconColorProp = props.iconColor, iconSize = props.iconSize;
    // TODO: should remove switchSize in release
    var size = switchSize(iconSize || sizeProp);
    var currentSize = RcIconSizes[size];
    var fontSize = typeof currentSize === 'number' ? px(currentSize) : currentSize;
    var iconColor = getParsePaletteColor(color || iconColorProp, null);
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n    cursor: ", ";\n    font-size: ", ";\n    color: ", ";\n  "], ["\n    display: inline-flex;\n    cursor: ", ";\n    font-size: ", ";\n    color: ", ";\n  "])), onClick && 'pointer', fontSize, iconColor);
};
var templateObject_1;
